import { render } from "./mobile.vue?vue&type=template&id=9366f7dc&scoped=true"
import script from "./mobile.vue?vue&type=script&lang=js"
export * from "./mobile.vue?vue&type=script&lang=js"

import "./mobile.vue?vue&type=style&index=0&id=9366f7dc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9366f7dc"

export default script